import { DefaultOptionType } from 'antd/es/select';

export enum DEPARTMENT_EMPLOYEE_COMPENSATION_TYPE {
  HOURLY = 'HOURLY',
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
}

export const DEPARTMENT_EMPLOYEE_COMPENSATION_TYPE_LABEL: Record<
  DEPARTMENT_EMPLOYEE_COMPENSATION_TYPE,
  string
> = {
  [DEPARTMENT_EMPLOYEE_COMPENSATION_TYPE.HOURLY]: '時薪',
  [DEPARTMENT_EMPLOYEE_COMPENSATION_TYPE.DAILY]: '日薪',
  [DEPARTMENT_EMPLOYEE_COMPENSATION_TYPE.MONTHLY]: '月薪',
};

export const DEPARTMENT_EMPLOYEE_COMPENSATION_TYPE_OPTIONS: DefaultOptionType[] =
  [
    {
      label: '時薪',
      value: DEPARTMENT_EMPLOYEE_COMPENSATION_TYPE.HOURLY,
    },
    {
      label: '日薪',
      value: DEPARTMENT_EMPLOYEE_COMPENSATION_TYPE.DAILY,
    },
    {
      label: '月薪',
      value: DEPARTMENT_EMPLOYEE_COMPENSATION_TYPE.MONTHLY,
    },
  ];
